// --- UTILS DE ESTILOS Y COLORES (CHIPS) ---

// -----------------------------------------------------------------------------
// 1. ESTADO DE PÓLIZA (General) - MANTENIDO
// Estilo OUTLINE: Borde de color + Fondo blanco
// -----------------------------------------------------------------------------
export const getEstadoChipClass = (estado) => {
  if (!estado) return 'border border-gray-300 text-gray-600 bg-white';
  
  switch(estado.toUpperCase()) {
    case 'VIGENTE': return 'border border-green-600 text-green-700 bg-white';
    case 'PENDIENTE DE EMISIÓN': return 'border border-orange-500 text-orange-600 bg-white';
    case 'PENDIENTE DE INSPECCIÓN': return 'border border-orange-700 text-orange-800 bg-white';
    case 'PROPUESTA INGRESADA': return 'border border-purple-600 text-purple-700 bg-white';
    case 'VENCIDA': return 'border border-red-600 text-red-700 bg-white';
    case 'ANULADA': return 'border border-red-800 text-red-900 bg-white'; 
    case 'NO INICIADA': return 'border border-blue-600 text-blue-700 bg-white';
    default: return 'border border-gray-400 text-gray-600 bg-white';
  }
};

// -----------------------------------------------------------------------------
// 2. MOTIVOS (Chip) - MANTENIDO
// Estilo PASTEL: Fondo suave + Texto oscuro
// -----------------------------------------------------------------------------
export const getMotivoChipClass = (motivo) => {
  if (!motivo) return 'bg-gray-100 text-gray-700';

  switch(motivo) {
      case 'Póliza Nueva': return 'bg-emerald-100 text-emerald-800';
      case 'Afiliación': return 'bg-emerald-100 text-emerald-800';
      case 'Renovación': return 'bg-indigo-100 text-indigo-800'; 
      case 'Refacturación': return 'bg-blue-100 text-blue-800';
      case 'Cambio de PAS': return 'bg-cyan-100 text-cyan-800';
      case 'Traspaso': return 'bg-cyan-100 text-cyan-800';
      case 'Cuenta Bancaria': return 'bg-teal-100 text-teal-800';
      case 'Emisión x Reemplazo': return 'bg-orange-100 text-orange-800';
      case 'Inclusión': return 'bg-blue-100 text-blue-800';
      default: return 'bg-gray-100 text-gray-800';
  }
};

// -----------------------------------------------------------------------------
// 3. PERSONAS (Vendedores/Suscriptores) - MANTENIDO
// Estilo PASTEL: Fondo muy suave
// -----------------------------------------------------------------------------
export const getPersonaChipClass = (persona) => {
    if (!persona) return 'bg-gray-100 text-gray-600';
    const p = persona.toLowerCase();

    // --- PERFILES FEMENINOS (Tonos Cálidos, Rosas y Turquesas) ---
    if (p.includes('agostina'))  return 'bg-[#ccfbf1] text-[#0f766e]'; // Turquesa/Teal
    if (p.includes('alejandra')) return 'bg-[#cffafe] text-[#0891b2]'; // Cian
    if (p.includes('maria'))     return 'bg-[#f3e8ff] text-[#9333ea]'; // Púrpura
    if (p.includes('rebeca'))    return 'bg-[#fce7f3] text-[#db2777]'; // Rosa
    if (p.includes('rocio'))     return 'bg-[#ede9fe] text-[#7c3aed]'; //
    if (p.includes('mariel'))    return 'bg-[#fae8ff] text-[#a21caf]'; // Fucsia Soft
    if (p.includes('victoria'))  return 'bg-[#fef9c3] text-[#a16207]'; // Ámbar/Amarillo
    if (p.includes('yamila'))    return 'bg-[#ffedd5] text-[#c2410c]'; // Naranja
    if (p.includes('carolina'))  return 'bg-[#ffdadb] text-[#900b09]'; // Rojo suave
    if (p.includes('vanesa'))  return 'bg-[#fed7aa] text-[#c2410c]'; //

    // --- PERFILES MASCULINOS (Tonos Fríos, Azules y Verdes) ---
    if (p.includes('daniel'))    return 'bg-[#e0f2fe] text-[#0284c7]'; // Celeste Sky
    if (p.includes('esteban'))   return 'bg-[#e0e7ff] text-[#4338ca]'; // Indigo
    if (p.includes('marcos'))    return 'bg-[#ddd6fe] text-[#5b21b6]'; // Violeta
    if (p.includes('martin'))    return 'bg-[#dbeafe] text-[#1e40af]'; // Azul Real
    if (p.includes('santiago'))  return 'bg-[#ecfccb] text-[#456b0d]'; // Lima
    if (p.includes('luis'))      return 'bg-[#dbeafe] text-[#1d4ed8]'; // Slate (Gris Azulado)
    if (p.includes('maxi'))      return 'bg-[#dcfce7] text-[#166534]'; // Verde
    if (p.includes('adrian'))    return 'bg-[#bfdbfe] text-[#1e3a8a]'; // Azul Oscuro
    if (p.includes('gadiel'))    return 'bg-[#d1fae5] text-[#059669]'; // Esmeralda,
    if (p.includes('facundo'))    return 'bg-[#dcfce7] text-[#15803d]'; // Verde
    if (p.includes('matias')) return 'bg-[#ffe4e6] text-[#be123c]'; // Coral/Rojo frambuesa

    return 'bg-gray-100 text-gray-600';
};


// -----------------------------------------------------------------------------
// CONSTANTE BASE PARA UNIFICACIÓN DE DISEÑO
// -----------------------------------------------------------------------------
const BASE_CHIP = "rounded-full px-3 py-1 text-[11px] font-bold uppercase tracking-wide border";

// -----------------------------------------------------------------------------
// 4. ESTADO DE ENDOSOS / GESTIÓN - UNIFICADO
// -----------------------------------------------------------------------------
export const getEndosoStatusChip = (status) => {
    if (!status) return `${BASE_CHIP} bg-gray-100 text-gray-600 border-gray-200`;

    const s = status.toLowerCase();

    if (s.includes('finalizado') || s.includes('gestionado')) {
        return `${BASE_CHIP} bg-[#dcfce7] text-[#166534] border-green-200`; // Verde
    }
    if (s.includes('pendiente')) {
        return `${BASE_CHIP} bg-[#fef9c3] text-[#854d0e] border-yellow-200`; // Amarillo
    }
    if (s.includes('proceso') || s.includes('cotizando')) {
        return `${BASE_CHIP} bg-[#dbeafe] text-[#1e40af] border-blue-200`; // Azul
    }
    if (s.includes('anulado') || s.includes('rechazado') || s.includes('reclamado')) {
        return `${BASE_CHIP} bg-[#fee2e2] text-[#991b1b] border-red-200`; // Rojo
    }

    return `${BASE_CHIP} bg-gray-100 text-gray-800 border-gray-200`;
};

// -----------------------------------------------------------------------------
// 5. ESTADO DE SINIESTROS - UNIFICADO
// -----------------------------------------------------------------------------
export const getSiniestroStatusChip = (status) => {
    if (!status) return `${BASE_CHIP} bg-gray-100 text-gray-600 border-gray-200`;

    const s = status.toUpperCase();

    if (s.includes('CERRADO') || s.includes('TERMINADO')) {
        return `${BASE_CHIP} bg-[#dcfce7] text-[#166534] border-green-200`; // Verde
    }
    if (s.includes('ABIERTO') || s.includes('CURSO')) {
        return `${BASE_CHIP} bg-[#fef9c3] text-[#854d0e] border-yellow-200`; // Amarillo
    }
    if (s.includes('RECHAZADO')) {
        return `${BASE_CHIP} bg-[#fee2e2] text-[#991b1b] border-red-200`; // Rojo
    }
    if (s.includes('PRESCRIBIÓ') || s.includes('PRESCRITO')) {
        return `${BASE_CHIP} bg-gray-200 text-gray-700 border-gray-300`; // Gris oscuro
    }
    if (s.includes('ESPERA') || s.includes('PENDIENTE')) {
        return `${BASE_CHIP} bg-orange-100 text-orange-800 border-orange-200`; // Naranja
    }

    return `${BASE_CHIP} bg-blue-50 text-blue-700 border-blue-200`; // Default Azul
};

// -----------------------------------------------------------------------------
// 6. ESTADO DE REFACTURACIÓN (CAUCIÓN) - UNIFICADO
// -----------------------------------------------------------------------------
export const getRefacturacionStatusChip = (status) => {
    if (!status) return `${BASE_CHIP} bg-gray-100 text-gray-400 border-gray-200`;
    
    const normalized = status.toLowerCase().trim();

    // Rojo Intenso (Crítico)
    if (normalized.includes('incobrable')) {
        return `${BASE_CHIP} bg-[#fecaca] text-[#b91c1c] border-red-200`; 
    }

    // Amarillo (Atención)
    if (normalized.includes('deuda reclamada')) {
        return `${BASE_CHIP} bg-[#fef9c3] text-[#854d0e] border-yellow-200`;
    }

    // Rojo Suave (Deuda)
    if (normalized.includes('deuda') || normalized.includes('moroso')) {
        return `${BASE_CHIP} bg-[#fee2e2] text-[#991b1b] border-red-200`;
    }

    // Azul Fuerte (Gestión)
    if (normalized.includes('falta recibo')) {
        return `${BASE_CHIP} bg-[#dbeafe] text-[#1e40af] border-blue-200`;
    }

    // Indigo (Revisión)
    if (normalized.includes('revision') || normalized.includes('revisión')) {
        return `${BASE_CHIP} bg-[#e0e7ff] text-[#3730a3] border-indigo-200`;
    }

    // Verde (Éxito)
    if (normalized.includes('abonado') || normalized.includes('debitada')) {
        return `${BASE_CHIP} bg-[#dcfce7] text-[#166534] border-green-200`;
    }
    
    // Cian (Enviado)
    if (normalized.includes('enviada')) {
        return `${BASE_CHIP} bg-cyan-50 text-cyan-700 border-cyan-200`;
    }

    // Gris (Finalizado/Anulado)
    if (normalized.includes('anulada') || normalized.includes('no renueva')) {
        return `${BASE_CHIP} bg-[#f3f4f6] text-[#374151] border-gray-300`;
    }

    return `${BASE_CHIP} bg-gray-100 text-gray-800 border-gray-200`;
};

// -----------------------------------------------------------------------------
// 7. ESTADO DE COBRANZA - UNIFICADO Y DESGLOSADO
// -----------------------------------------------------------------------------
export const getCobranzaStatusChip = (status) => {
  if (!status) return `${BASE_CHIP} bg-gray-100 text-gray-600 border-gray-200`;

  const s = status.toLowerCase();

  // 1. Amarillo (Estados Iniciales)
  if (s === 'pendiente') {
    return `${BASE_CHIP} bg-[#fef9c3] text-[#854d0e] border-yellow-200`;
  }

  // 2. Azul (Comunicación)
  if (s === 'informada') {
    return `${BASE_CHIP} bg-[#dbeafe] text-[#1e40af] border-blue-200`;
  }

  // 3. Índigo (Procesos de Regularización)
  if (
    s.includes('readherido') ||
    s.includes('compromiso de pago') ||
    s.includes('plan de pago')
  ) {
    return `${BASE_CHIP} bg-[#e0e7ff] text-[#3730a3] border-indigo-200`;
  }

  // 4. Violeta (Gestión Activa de Cobro)
  if (s.includes('intento de cobro')) {
    return `${BASE_CHIP} bg-[#f5f3ff] text-[#5b21b6] border-violet-200`;
  }

  // 5. Rosa (Rechazos)
  if (s.includes('rechazo')) {
    return `${BASE_CHIP} bg-[#fdf2f8] text-[#9d174d] border-pink-200`;
  }

  // 6. Naranja (Escalada / Reclamos)
  if (s === 'reclamada') {
    return `${BASE_CHIP} bg-[#ffedd5] text-[#c2410c] border-orange-200`;
  }

  // 7. Verde (Cobro Exitoso)
  if (
    s === 'cobrada' ||
    s === 'debitada' ||
    s.includes('acreditada') ||
    s.includes('al día')
  ) {
    return `${BASE_CHIP} bg-[#dcfce7] text-[#166534] border-green-200`;
  }

  // 8. Rojo (Crítico)
  if (
    s === 'incobrable' ||
    s.includes('fallido') ||
    s.includes('deuda') ||
    s.includes('mora') ||
    s.includes('legales') ||
    s.includes('judicial')
  ) {
    return `${BASE_CHIP} bg-[#fee2e2] text-[#991b1b] border-red-200`;
  }

  // 9. Gris (Anulaciones)
  if (s === 'anulada') {
    return `${BASE_CHIP} bg-gray-200 text-gray-700 border-gray-300`;
  }

  return `${BASE_CHIP} bg-gray-100 text-gray-600 border-gray-200`;
};

// -----------------------------------------------------------------------------
// ESTADO DE CONTRATO
// -----------------------------------------------------------------------------
export const getContratoStatusChip = (status) => {
  if (!status) return `${BASE_CHIP} bg-gray-100 text-gray-600 border-gray-200`;

  const s = status.toLowerCase();

  // 1. Verde (Normalizado)
  if (s === 'normalizado') {
    return `${BASE_CHIP} bg-[#dcfce7] text-[#166534] border-green-200`;
  }

  // 2. Amarillo (Proceso de Intimación)
  if (s.includes('intimación')) {
    return `${BASE_CHIP} bg-[#fef9c3] text-[#854d0e] border-yellow-200`;
  }

  // 3. Naranja (Proceso de Anulación)
  if (s.includes('anulación')) {
    return `${BASE_CHIP} bg-[#ffedd5] text-[#c2410c] border-orange-200`;
  }

  // 4. Rojo (Suspendido)
  if (s === 'suspendido') {
    return `${BASE_CHIP} bg-[#fee2e2] text-[#991b1b] border-red-200`;
  }

  // 5. Gris (Anulado)
  if (s === 'anulado') {
    return `${BASE_CHIP} bg-gray-200 text-gray-700 border-gray-300`;
  }

  return `${BASE_CHIP} bg-gray-100 text-gray-600 border-gray-200`;
};

// -----------------------------------------------------------------------------
// 8. FORMA DE PAGO - UNIFICADO
// -----------------------------------------------------------------------------
export const getFormaPagoChip = (forma) => {
  if (!forma) return `${BASE_CHIP} bg-gray-100 text-gray-600 border-gray-200`;

  const f = forma.toUpperCase();

  // Morado (Tarjetas)
  if (f.includes('TARJETA') || f === 'TC') {
    return `${BASE_CHIP} bg-purple-50 text-purple-700 border-purple-100`;
  }

  // Teal (Bancos/CBU)
  if (f.includes('CBU') || f.includes('DEBITO')) {
    return `${BASE_CHIP} bg-teal-50 text-teal-700 border-teal-100`;
  }

  // Naranja (Efectivo/Cupones)
  if (f.includes('CUPON') || f.includes('EFECTIVO')) {
    return `${BASE_CHIP} bg-orange-50 text-orange-700 border-orange-100`;
  }

  return `${BASE_CHIP} bg-slate-50 text-slate-600 border-slate-200`;
};

// -----------------------------------------------------------------------------
// 9. CLASIFICACIÓN CLIENTE - UNIFICADO
// -----------------------------------------------------------------------------
export const getClasificacionChip = (clasificacion) => {
  if (!clasificacion) return `${BASE_CHIP} bg-gray-100 text-gray-600 border-gray-200`;
  
  const c = clasificacion.toUpperCase();

  switch(c) {
      case 'CALIFICADO': 
        return `${BASE_CHIP} bg-[#dcfce7] text-[#166534] border-green-200`;
      
      case 'FRAUDULENTO': 
      case 'SINIESTRABLE': 
        return `${BASE_CHIP} bg-[#fee2e2] text-[#991b1b] border-red-200`;
      
      case 'MOROSO': 
        return `${BASE_CHIP} bg-[#fef9c3] text-[#854d0e] border-yellow-200`;
      
      case 'QUEJOSO': 
        return `${BASE_CHIP} bg-purple-50 text-purple-700 border-purple-200`;
      
      case 'INCOBRABLE': 
        return `${BASE_CHIP} bg-gray-800 text-white border-gray-600`;
      
      default: 
        return `${BASE_CHIP} bg-gray-100 text-gray-600 border-gray-200`;
  }
};

export const estadoCotizacionArt = (estado) => {
  if (!estado) return 'border border-slate-400 text-slate-600 bg-white';

  switch (estado.toUpperCase()) {
    case 'PENDIENTE':
      return 'border border-slate-600 text-slate-800 bg-white';

    case 'SOLICITUD DE COTIZACIÓN':
      return 'border border-sky-500 text-sky-600 bg-white';

    case 'COTIZANDO':
      return 'border border-blue-600 text-blue-700 bg-white';

    case 'ESPERANDO RESPUESTA':
      return 'border border-amber-600 text-amber-700 bg-white';

    case 'SEGUIMIENTO':
      return 'border border-orange-500 text-orange-600 bg-white';

    case 'GESTIÓN FINALIZADA':
      return 'border border-teal-500 text-teal-700 bg-white';

    case 'SIN RESPUESTA':
      return 'border border-yellow-500 text-yellow-700 bg-white';

    case 'CERRADA GANADA':
      return 'border border-green-600 text-green-700 bg-white';

    case 'CERRADA PERDIDA':
      return 'border border-red-700 text-red-800 bg-white';

    case 'CANCELADA POR EL CLIENTE':
      return 'border border-purple-600 text-purple-700 bg-white';

    case 'SIN COSTO':
      return 'border border-slate-500 text-slate-600 bg-white';

    default:
      return 'border border-slate-400 text-slate-600 bg-white';
  }
};

export const getCotizacionColor = (estado) => {
    const e = String(estado).trim(); 
    if (e === 'Cerrada Ganada') return '!bg-green-100 !text-green-800 !border-green-300 font-bold';
    if (e === 'Cerrada Perdida') return '!bg-red-100 !text-red-800 !border-red-300 font-bold';
    if (e === 'En Seguimiento') return '!bg-purple-100 !text-purple-800 !border-purple-300 font-bold';
    if (e === 'En Cotización') return '!bg-blue-100 !text-blue-800 !border-blue-300 font-bold';
    if (e === 'Cancelada por el Cliente') return '!bg-gray-200 !text-gray-700 !border-gray-300 font-bold';
    if (e === 'Sin Costo') return '!bg-purple-100 !text-purple-800 !border-purple-300 font-bold';
    return '!bg-orange-50 !text-orange-800 !border-orange-200 font-bold'; 
};

export const tipoGestionArt = (estado) => {
  if (!estado) return 'bg-gray-100 text-gray-800';
  
  // ALERTA DE FIX: Convertimos a mayúsculas, así que los CASE deben ser MAYÚSCULAS
  switch(estado.toUpperCase()) {
    case 'VENTA NUEVA': return 'bg-emerald-100 text-emerald-800';
    case 'RECOTIZACIÓN DE CLIENTE': return 'bg-indigo-100 text-indigo-800';
    case 'AUMENTO DE TARIFA': return 'bg-orange-100 text-orange-800';
    default: return 'bg-gray-100 text-gray-800';
  }
};

export const getEstadoRenovacion = (renovacion) => {
    if (!renovacion) return 'bg-slate-100 text-slate-500 border-slate-200';

    const estado = renovacion.toUpperCase();

    switch(estado) {
        // Estados de Proceso (Azules / Violetas)
        case 'RECOTIZANDO': 
            return 'bg-violet-100 text-violet-700 border-violet-200'; 
       
        case 'CONSULTE SI RENUEVA': 
            return 'bg-blue-100 text-blue-700 border-blue-200';
        
        // Estados de Facturación / Revisión (Cian / Turquesa / Teal)
        case 'REFACTURACION': 
            return 'bg-teal-100 text-teal-700 border-teal-200';
        
        case 'REVISION': 
            return 'bg-cyan-100 text-cyan-700 border-cyan-300';

        case 'PENDIENTE DE ENVIO': 
        return 'bg-rose-500 text-slate-50 border-rose-300';
            
        case 'PLAN DE PAGO': 
            return 'bg-sky-100 text-sky-700 border-sky-200';

        // Estados de Alerta o Negativos (Rojos / Naranjas / Grises)
        case 'DEUDA INFORMADA': 
            return 'bg-rose-100 text-rose-700 border-rose-200';
            
        case 'ANULADA': 
            return 'bg-slate-200 text-slate-600 border-slate-300';
            
        case 'NO RENUEVA': 
            return 'bg-zinc-200 text-zinc-700 border-zinc-300';

        // Estados de Éxito (Verdes)
        case 'RENOVADA': 
            return 'bg-emerald-100 text-emerald-700 border-emerald-200';
        
        default: 
            return 'bg-gray-100 text-gray-600 border-gray-200';
    }
};

export const getEstadoEndosoArt = (estado) => {
    const e = String(estado).trim();

    if (e === 'Gestionado') return '!bg-green-100 !text-green-800 !border-green-300 font-bold';
    if (e === 'Cotizado') return '!bg-purple-100 !text-purple-800 !border-purple-300 font-bold';
    if (e === 'Pendiente') return '!bg-blue-100 !text-blue-800 !border-blue-300 font-bold';
    if (e === 'Informado') return '!bg-cyan-100 !text-cyan-800 !border-cyan-300 font-bold';

    return '!bg-orange-50 !text-orange-800 !border-orange-200 font-bold';
};


export const estadoCotizacionArtRow = (estado) => {
    switch (estado) {
        case 'Cotizada':
            return {
                className: 'bg-emerald-50 text-emerald-700 border-emerald-200',
                dot: 'bg-emerald-500'
            };

        case 'Solicitada':
            return {
                className: 'bg-sky-50 text-sky-700 border-sky-200',
                dot: 'bg-sky-500'
            };

        case 'Bloqueada':
            return {
                className: 'bg-amber-50 text-amber-700 border-amber-200',
                dot: 'bg-amber-500'
            };

        case 'No cotiza':
            return {
                className: 'bg-rose-50 text-rose-700 border-rose-200',
                dot: 'bg-rose-500'
            };

        default:
            return {
                className: 'bg-slate-50 text-slate-700 border-slate-200',
                dot: 'bg-slate-500'
            };
    }
};

export const estadoGestionCroselling = (estado) => {
    const e = String(estado).trim();

    if (e === 'Pendiente') return '!bg-indigo-100 !text-indigo-700 !border-indigo-300 font-bold';
    if (e === 'Contactado') return '!bg-blue-100 !text-blue-800 !border-blue-300 font-bold';
    if (e === 'Cotizado') return '!bg-purple-100 !text-purple-800 !border-purple-300 font-bold';
    if (e === 'En Negociación') return '!bg-orange-100 !text-orange-800 !border-orange-300 font-bold';
    if (e === 'Cerrado Ganado') return '!bg-green-100 !text-green-800 !border-green-300 font-bold';
    if (e === 'Cerrado Perdido') return '!bg-red-100 !text-red-800 !border-red-300 font-bold';

    return '!bg-gray-100 !text-gray-700 !border-gray-300 font-bold';
};